import {createFileRoute} from "@tanstack/react-router";
import {ProfileSafety} from "@/components/profile/safety/ProfileSafety";

export const Route = createFileRoute("/_mainLayout/profile/safety/")({
  component: ProfileSafety,
});
